import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'
import { areaPubblicaApi } from '../../api/api.area.pubblica.service'
import { coursesApi } from '../../api/api.courses.service'

export default {
  [actionTypes.GET_AREA_LIST](store) {
    if (store.getters.areaList && store.getters.areaList.length) {
      return Promise.resolve()
    } else {
      return areaPubblicaApi.getAreaList().then(res => {
        return store.commit(mutationTypes.AREA_LIST_UPDATED, res)
      })
    }
  },
  [actionTypes.GET_AREA_TEMATICA_LIST](store) {
    if (
      store.getters.areaTematicaList &&
      store.getters.areaTematicaList.length
    ) {
      return Promise.resolve()
    } else {
      return areaPubblicaApi.getAreaTematicaList().then(res => {
        return store.commit(mutationTypes.AREA_TEMATICA_LIST_UPDATED, res)
      })
    }
  },
  [actionTypes.GET_REGIONE_LIST](store) {
    if (store.getters.regioneList && store.getters.regioneList.length) {
      return Promise.resolve()
    } else {
      return areaPubblicaApi.getRegioneList().then(res => {
        return store.commit(mutationTypes.REGIONE_LIST_UPDATED, res)
      })
    }
  },
  [actionTypes.GET_AREA_RISERVATA_ENUM_LIST](store) {
    if (
      store.getters.areaRiservataEnumList &&
      store.getters.areaRiservataEnumList.length
    ) {
      return Promise.resolve()
    } else {
      return areaPubblicaApi.getAreaRiservataEnumList().then(res => {
        return store.commit(mutationTypes.AREA_RISERVATA_ENUM_LIST_UPDATED, res)
      })
    }
  },
  [actionTypes.GET_TRAINING_COURSE_TYPES_LIST](store) {
    if (
      store.getters.trainingCourseTypesList &&
      store.getters.trainingCourseTypesList.length
    ) {
      return Promise.resolve()
    } else {
      return coursesApi.getTrainingCourseTypes().then(res => {
        return store.commit(
          mutationTypes.TRAINING_COURSE_TYPES_LIST_UPDATED,
          res
        )
      })
    }
  },
}
